import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../apiServices/auth.service";


const AdminLogin = () => {
  const navigate = useNavigate();

  // Estados
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Redirigir si ya tiene sesión activa completa (tanto token como usuario están presentes)
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    if (token && user) {
      navigate("/admin/articulos", { replace: true });
    }
  }, [navigate]);

  // Redirección al flujo de Google OAuth
  const handleGoogleLogin = () => {
    setLoading(true);
    const beApiUrl =
      process.env.REACT_APP_BE_API_URL ||
      "https://cgweb-be-dev-822418970058.us-central1.run.app";
    const redirectState = `${window.location.origin}/admin/login`;

    // Redirigir al endpoint de Google Auth del Backend
    window.location.href = `${beApiUrl}/auth/google?state=${encodeURIComponent(redirectState)}`;
  };

  // Manejo del callback de Google OAuth (token en query params)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const errorFromUrl = params.get("error");

    if (errorFromUrl === "USER_NOT_FOUND") {
      setError(
        "No se encontró una cuenta asociada a este usuario. Si considera que debería tener acceso, comuníquese con un administrador.",
      );

      window.history.replaceState({}, document.title, window.location.pathname);

      return;
    }

    const tokenFromUrl = params.get("accessToken");

    if (tokenFromUrl) {
      localStorage.setItem("token", tokenFromUrl);

      authService
        .getMe()
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.user));
          localStorage.setItem("lastActivity", Date.now().toString());

          window.history.replaceState(
            {},
            document.title,
            window.location.pathname,
          );

          navigate("/admin/articulos");
        })
        .catch((err) => {
          console.error("Error al obtener perfil tras Google Login:", err);

          setError(
            "Error al recuperar el perfil de Google. Inténtalo nuevamente.",
          );

          setLoading(false);
        });
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f0f2f5",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: 480,
          borderRadius: "24px",
          background: "#fff",
          padding: "48px 40px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <img
            src="/logo20.webp"
            alt="Consultoría Global 20 años"
            style={{
              width: "auto",
              height: 90,
              display: "block",
            }}
          />
        </Box>

        <Box
          sx={{
            textAlign: "center",
            mb: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#1a1f2b",
              letterSpacing: "-0.5px",
              mb: 1,
            }}
          >
            Panel de administración de WEB CG
          </Typography>

          <Typography
            sx={{
              fontSize: "15px",
              color: "#71717a",
              fontWeight: 400,
            }}
          >
            Iniciá sesión con tu cuenta Google corporativa
          </Typography>
        </Box>

        {error && (
          <Alert
            severity="error"
            sx={{
              width: "100%",
              mb: 3,
              borderRadius: "10px",
            }}
          >
            {error}
          </Alert>
        )}

        <Button
          fullWidth
          onClick={handleGoogleLogin}
          disabled={loading}
          variant="outlined"
          sx={{
            height: 58,
            borderRadius: "14px",
            border: "1px solid #e4e4e7",
            background: "#fff",
            color: "#18181b",
            fontSize: "16px",
            fontWeight: 500,
            textTransform: "none",
            gap: "12px",
            boxShadow: "0 1px 2px rgba(0,0,0,.05)",

            "&:hover": {
              background: "#f4f4f5",
              borderColor: "#d4d4d8",
            },
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} />
              Conectando...
            </>
          ) : (
            <>
              <img src="/google-icon.svg" alt="Google" width={20} height={20} />
              Ingresar con Google
            </>
          )}
        </Button>

        <Typography
          sx={{
            mt: 3,
            fontSize: "12px",
            color: "#9ca3af",
            textAlign: "center",
          }}
        >
          Acceso restringido a personal autorizado
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdminLogin;
